<template>
    <div class="container-fluid mt-5">
        <div class="card" style="width: 100%; margin: 1 auto;">
            <div class="card-body">
                <h1>{{ activeTab === 'abordaje' ? 'Abordaje' : 'Abordaje fuera de tiempo' }}</h1>
                <br>
                <el-tabs v-model="activeTab">

                    <!-- ===== TAB 1: ABORDAJE ===== -->
                    <el-tab-pane label="Abordaje" name="abordaje">
                <br>
                <div v-if="subcorridas != null" class="input-group w-auto">
                    <multiselect v-model="route" @input="selectSubRoute" :options="subcorridas" placeholder="Selecccione corrida" :custom-label="nombreCompleto" track-by="id" :showLabels="false"></multiselect>
                </div>
                <br>
                <template v-if="subRoute" class="mb-3">
                    <h1>Información de Corrida #{{ subRoute.corrida_id }}</h1>
                    <br>
                    <h4>Sub-Corridas: <span v-for="(subcorrida, index) in searchSubcorridas" :key="index">#{{ subcorrida }} </span></h4>
                    <h4>Fecha / Hora de salida: {{ subRoute.fecha_salida }}</h4>
                    <h4>Salida confirmada: {{ subRoute.fecha_salida_confirmada }}</h4>
                    <br>
                    <h4>Terminal Origen: {{ subRoute.terminal_origen }}</h4>
                    <h4>Terminales Destino: {{ route && route.terminales_destino }} </h4>
                    <br>
                    <div class="row">
                        <div class="col-md-3">
                            <button :disabled="confirmaSalida" class="btn btn-primary" type="primary" icon size="sm" @click="confirmDeparture(route.subcorridas_ids)">
                                <span class="btn-inner--text">Confirmar Salida</span>
                            </button>
                        </div>
                        <div class="col-md-3">
                            <base-button
                                type="button"
                                class="btn btn-default hover-apolo mb-1"
                                native-type="submit"
                                @click="listaAbordajeModal(subRoute.corrida_id)"          
                            >
                                Lista de Abordaje
                            </base-button>
                        </div>
                        <div class="col-md-3">
                            <base-button
                                type="button"
                                class="btn btn-default hover-apolo mb-1"
                                native-type="submit"
                                @click="confirmBoardingQR"          
                            >
                                Confirmar Abordaje con QR
                            </base-button>
                        </div>
                        <div class="col-md-3">
                            <base-input v-model="lector" ref="lectorInput" @keyup="onScan" placeholder="Abordar desde lector..." > </base-input>
                        </div>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group mb-3 ml-2">
                            <input type="text" class="form-control w-10" placeholder="Buscar por boleto" v-model="searchScroll"
                                @keyup.enter="scrollToResult">
                            <div class="input-group-append">
                                <button class="btn btn-default ml-auto" type="button" @click="scrollToResult">Buscar</button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive align-items-center table-flush">
                        <table class="table header-white">
                            <thead>
                                <tr>
                                    <th v-for="(header, index) in headers" :key="index" class="two-lines">{{ header.text }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="items.length">
                                    <tr v-for="(item, index) in items" :key="index">
                                        <td v-for="(header, index) in headers" :key="index">
                                            
                                            <template v-if="header.value === 'pasajeros'">
                                                <span v-for="(pasajero, pasajeroIndex) in item.pasajeros" :key="pasajeroIndex">
                                                    <span :style="{ 'font-weight': isBold(item, pasajero, pasajeroIndex) ? 'bold' : 'normal' }">
                                                        {{ pasajero }} / {{ item.sube[pasajeroIndex] }} - {{ item.baja[pasajeroIndex] }}
                                                    </span>
                                                    <br v-if="pasajeroIndex < item.pasajeros.length - 1" />
                                                </span>
                                            </template>

                                            <template v-if="header.value === 'asiento'">
                                                {{ !item.boleto ? item.numero[index] : '' }}
                                            </template>

                                            <template v-if="header.value === 'btn_doc'">
                                                <template v-if="item.boleto && item.boleto.abordado === 0 && permisoAbordaje">
                                                    <button class="btn btn-primary"
                                                        @click="showModalAdditional = { show: true, item: item.boleto }">Canjear
                                                        Blanco</button>
                                                    <template
                                                        v-if="item.boleto.liquidado === 1 && !item.boleto.equipajes.some(equipaje => !equipaje.documentado)">
                                                        <button class="btn btn-primary"
                                                            @click="confirmBoarding(item.boleto, 'lista')">Confirmar
                                                            Abordaje</button>
                                                    </template>
                                                </template>
                                                <template v-if="item.boleto && item.boleto.abordado === 1 && permisoAbordaje">
                                                    <button class="btn btn-primary"
                                                            @click="cancelBoarding(item.boleto)">Cancelar
                                                            Abordaje</button>
                                                </template>
                                            </template>
                                            <template v-else-if="header.value === 'piezas_equipaje'">
                                                <template v-if="item.boleto && item.boleto.equipajes.length === 0">
                                                    Sin piezas de equipaje
                                                </template>
                                                <template v-else-if="item.boleto">
                                                    <div v-for="(equipaje, index) in item.boleto.equipajes" :key="index">
                                                        <span class="hipervinculo"
                                                            @click.stop="togglePopover(equipaje, $event)"
                                                            v-on:click="showEquipajeDescripcion(equipaje.descripcion_equipaje, equipaje)">
                                                            # {{ equipaje.id }}</span> - {{ equipaje.documentado ?
                                                                'Documentado' : 'No documentado' }} 
                                                                <base-button v-if="equipaje.documentado === 1 && equipaje.abordado === 0 && permiso" type="primary" title="Confirmar Abordaje de Equipaje" icon size="sm" @click="confirmBoardingBaggage(equipaje)">
                                                                    <span class="btn-inner--icon"><i class="fas fa-luggage-cart"></i></span>
                                                                </base-button>
                                                                <base-button v-if="equipaje.documentado === 1 && equipaje.abordado === 1 && permiso" type="danger" title="Cancelar Abordaje de Equipaje" icon size="sm" @click="cancelBoardingBaggage(equipaje)">
                                                                    <span class="btn-inner--icon"><i class="fas fa-luggage-cart"></i></span>
                                                                </base-button>
                                                        <el-popover style="position: relative !important;" ref="popover" v-if="equipaje === selectedEquipaje"
                                                            placement="top" width=auto trigger="manual"
                                                            @hide="selectedEquipaje = null" v-model="isPopoverVisible"
                                                            v-click-outside="onClickOutside">
                                                            {{ equipajeDescripcion }}
                                                        </el-popover>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else-if="header.value === 'abordado'">
                                                <div v-if="item.boleto"
                                                    :style="{ backgroundColor: item.boleto[header.value] === 1 ? '#88D498' : item.boleto[header.value] === 0 ? '#EFD263' : '' }">
                                                    {{ item.boleto[header.value] === 1 ? 'Sí' : (item.boleto[header.value]
                                                        === 0 ? 'No' : '') }}
                                                </div>
                                            </template>
                                            <template v-else-if="header.value === 'id'">
                                                {{ item.boleto ? item.boleto[header.value] : item.boleto_pasajero[0] }}
                                                {{ item.boleto && item.boleto.liquidado === 0 ? ' - (Sin liquidar) ' : '' }}
                                            </template>
                                            <template v-else>{{ item.boleto ? item.boleto[header.value] : '' }}</template>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="7" class="text-center">Sin datos disponibles</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <br>
                </template>

                    </el-tab-pane>

                    <!-- ===== TAB 2: ABORDAJE FUERA DE TIEMPO ===== -->
                    <el-tab-pane label="Abordaje fuera de tiempo" name="fuera_de_tiempo">
                        <br>
                        <div v-if="subcorridasFdt != null" class="input-group w-auto">
                            <multiselect v-model="routeFdt" @input="selectSubRouteFdt" :options="subcorridasFdt" placeholder="Selecccione corrida" :custom-label="nombreCompleto" track-by="id" :showLabels="false"></multiselect>
                        </div>
                        <br>
                        <template v-if="subRoute" class="mb-3">
                            <h1>Información de Corrida #{{ subRoute.corrida_id }}</h1>
                            <br>
                            <h4>Sub-Corridas: <span v-for="(subcorrida, index) in searchSubcorridas" :key="index">#{{ subcorrida }} </span></h4>
                            <h4>Fecha / Hora de salida: {{ subRoute.fecha_salida }}</h4>
                            <h4>Salida confirmada: {{ subRoute.fecha_salida_confirmada }}</h4>
                            <br>
                            <h4>Terminal Origen: {{ subRoute.terminal_origen }}</h4>
                            <h4>Terminales Destino: {{ routeFdt && routeFdt.terminales_destino }}</h4>
                            <br>
                            <div class="row">
                                <div class="col-md-3">
                                    <button :disabled="confirmaSalida" class="btn btn-primary" type="primary" icon size="sm" @click="confirmDeparture(routeFdt.subcorridas_ids)">
                                        <span class="btn-inner--text">Confirmar Salida</span>
                                    </button>
                                </div>
                                <div class="col-md-3">
                                    <base-button type="button" class="btn btn-default hover-apolo mb-1" native-type="submit" @click="listaAbordajeModal(subRoute.corrida_id)">
                                        Lista de Abordaje
                                    </base-button>
                                </div>
                                <div class="col-md-3">
                                    <base-button type="button" class="btn btn-default hover-apolo mb-1" native-type="submit" @click="confirmBoardingQR">
                                        Confirmar Abordaje con QR
                                    </base-button>
                                </div>
                                <div class="col-md-3">
                                    <base-input v-model="lector" ref="lectorInput" @keyup="onScan" placeholder="Abordar desde lector..."></base-input>
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group mb-3 ml-2">
                                    <input type="text" class="form-control w-10" placeholder="Buscar por boleto" v-model="searchScroll" @keyup.enter="scrollToResult">
                                    <div class="input-group-append">
                                        <button class="btn btn-default ml-auto" type="button" @click="scrollToResult">Buscar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive align-items-center table-flush">
                                <table class="table header-white">
                                    <thead>
                                        <tr>
                                            <th v-for="(header, index) in headers" :key="index" class="two-lines">{{ header.text }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="items.length">
                                            <tr v-for="(item, index) in items" :key="index">
                                                <td v-for="(header, hIndex) in headers" :key="hIndex">
                                                    <template v-if="header.value === 'pasajeros'">
                                                        <span v-for="(pasajero, pasajeroIndex) in item.pasajeros" :key="pasajeroIndex">
                                                            <span :style="{ 'font-weight': isBold(item, pasajero, pasajeroIndex) ? 'bold' : 'normal' }">
                                                                {{ pasajero }} / {{ item.sube[pasajeroIndex] }} - {{ item.baja[pasajeroIndex] }}
                                                            </span>
                                                            <br v-if="pasajeroIndex < item.pasajeros.length - 1" />
                                                        </span>
                                                    </template>
                                                    <template v-if="header.value === 'asiento'">
                                                        {{ !item.boleto ? item.numero[hIndex] : '' }}
                                                    </template>
                                                    <template v-if="header.value === 'btn_doc'">
                                                        <template v-if="item.boleto && item.boleto.abordado === 0 && permisoAbordaje">
                                                            <button class="btn btn-primary" @click="showModalAdditional = { show: true, item: item.boleto }">Canjear Blanco</button>
                                                            <template v-if="item.boleto.liquidado === 1">
                                                                <button class="btn btn-primary" @click="confirmBoarding(item.boleto, 'lista')">Confirmar Abordaje</button>
                                                            </template>
                                                        </template>
                                                        <template v-if="item.boleto && item.boleto.abordado === 1 && permisoAbordaje">
                                                            <button class="btn btn-primary" @click="cancelBoarding(item.boleto)">Cancelar Abordaje</button>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="header.value === 'piezas_equipaje'">
                                                        <template v-if="item.boleto && item.boleto.equipajes.length === 0">Sin piezas de equipaje</template>
                                                        <template v-else-if="item.boleto">
                                                            <div v-for="(equipaje, eIndex) in item.boleto.equipajes" :key="eIndex">
                                                                <span class="hipervinculo" @click.stop="togglePopover(equipaje, $event)" v-on:click="showEquipajeDescripcion(equipaje.descripcion_equipaje, equipaje)">
                                                                    # {{ equipaje.id }}</span> - {{ equipaje.documentado ? 'Documentado' : 'No documentado' }}
                                                                <base-button v-if="equipaje.documentado === 1 && equipaje.abordado === 0 && permiso" type="primary" title="Confirmar Abordaje de Equipaje" icon size="sm" @click="confirmBoardingBaggage(equipaje)">
                                                                    <span class="btn-inner--icon"><i class="fas fa-luggage-cart"></i></span>
                                                                </base-button>
                                                                <base-button v-if="equipaje.documentado === 1 && equipaje.abordado === 1 && permiso" type="danger" title="Cancelar Abordaje de Equipaje" icon size="sm" @click="cancelBoardingBaggage(equipaje)">
                                                                    <span class="btn-inner--icon"><i class="fas fa-luggage-cart"></i></span>
                                                                </base-button>
                                                                <el-popover style="position: relative !important;" ref="popover" v-if="equipaje === selectedEquipaje" placement="top" width=auto trigger="manual" @hide="selectedEquipaje = null" v-model="isPopoverVisible" v-click-outside="onClickOutside">
                                                                    {{ equipajeDescripcion }}
                                                                </el-popover>
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="header.value === 'abordado'">
                                                        <div v-if="item.boleto" :style="{ backgroundColor: item.boleto[header.value] === 1 ? '#88D498' : item.boleto[header.value] === 0 ? '#EFD263' : '' }">
                                                            {{ item.boleto[header.value] === 1 ? 'Sí' : (item.boleto[header.value] === 0 ? 'No' : '') }}
                                                        </div>
                                                    </template>
                                                    <template v-else-if="header.value === 'id'">
                                                        {{ item.boleto ? item.boleto[header.value] : item.boleto_pasajero[0] }}
                                                        {{ item.boleto && item.boleto.liquidado === 0 ? ' - (Sin liquidar) ' : '' }}
                                                    </template>
                                                    <template v-else>{{ item.boleto ? item.boleto[header.value] : '' }}</template>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr><td colspan="7" class="text-center">Sin datos disponibles</td></tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <br>
                        </template>
                    </el-tab-pane>

                </el-tabs>

                <!-- MODAL TOKEN ABORDAJE FUERA DE TIEMPO -->
                <modal :show.sync="showModalTokenFdt" modal-classes="modal-primary" size="sm">
                    <h6 slot="header" class="mb-0 modal-title">Solicitud de token</h6>
                    <form class="new-event--form" @submit.prevent="confirmarTokenFdt">
                        <base-input label="Ingresa token:">
                            <input type="text" class="form-control" placeholder="Token" v-model="tokenFdtInput" />
                        </base-input>
                        <input type="hidden" class="new-event--start"/>
                        <input type="hidden" class="new-event--end"/>
                    </form>
                    <template slot="footer">
                        <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="confirmarTokenFdt">Aceptar</button>
                        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="cancelarTokenFdt">Cancelar</button>
                    </template>
                </modal>

                <template class="modal" v-if="showModalAdditional">
                    <div tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-dialog-centered fixed-top" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Canje Blanco de Boleto #{{ showModalAdditional.item.id }}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                        @click="closeModalAdditional">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <p>El Boleto del Pasajero {{ showModalAdditional.item.nombre_pasajero }} será canjeado.
                                    </p>
                                    <div>
                                        <input type="checkbox" v-model="selected" />
                                        <label> &nbsp; Adelantar un boleto a este asiento</label>
                                        <div class="input-group mb-3" v-if="selected">
                                            <input type="text" class="form-control search-size02"
                                                placeholder="Buscar boleto" v-model="searchTicketInput"
                                                @keyup.enter="searchTicket({ searchText: searchTicketInput, itemId: showModalAdditional.item.id })">
                                            <div class="input-group-append">
                                                <button class="btn btn-default ml-auto" type="button"
                                                    @click="searchTicket({ searchText: searchTicketInput, itemId: showModalAdditional.item.id })">Buscar</button>
                                            </div>
                                        </div>
                                        <div v-if="infoBoleto">
                                            <h4>El Boleto es correcto para adelantar:</h4>
                                            <br>
                                            <h5>Pasajero: {{ infoBoleto.nombre_pasajero }}</h5>
                                            <h5>Asiento origen: {{ infoBoleto.asiento }}</h5>
                                            <h5>Fecha / Hora de origen: {{ infoBoleto.fecha_salida }}</h5>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-primary"
                                        @click="selected ? canjeBlanco({ boleto_a_blanco_id: showModalAdditional.item.id, se_adelanta_boleto: true, boleto_adelantar_id: infoBoleto.id }) : canjeBlanco(showModalAdditional.item.id)">Aceptar</button>
                                    <button type="button" class="btn btn-secondary"
                                        @click="closeModalAdditional">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>


                <template v-else-if="error">
                    <p>{{ error }}</p>
                </template>
            </div>
        </div>
        <!-- MODAL VER LISTA DE ABORDAJE -->
        <modal :show.sync="showListaAbordajeModal" :close-on-backdrop="true" modal-classes="modal-primary" size="lg">
            <div class="row">
            <h6 slot="header" class="mb-0 modal-title col-6">Lista de abordaje de corrida</h6>
            <button class="btn btn-default hover-apolo new-event--add ml-2 col-4" align="right" @click="imprimirListaAbordaje()">Imprimir</button>
            </div>
            <form class="new-event--form">
            <span v-if="TotalVentaCorrida != null">Total de venta corrida: ${{ TotalVentaCorrida }}</span>
            <br>
            <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="listaAbordaje"
                >
                <div slot="empty" v-if="loading">
                    <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>

                <div slot="empty" v-if="listaAbordaje">
                    Sin datos disponibles
                </div>
        
                <el-table-column label="Asiento" prop="numero" />
                <el-table-column label="Categoría" prop="categoria.nombre" />
                <el-table-column label="Pasajero">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.boleto">
                        <span>{{row.boleto.nombre_pasajero}}</span>
                    </div>
                    <div v-else-if="row.pasajeros">
                        <div v-for="(pasajero, index) in row.pasajeros" :key="pasajero.id">
                            <span>{{pasajero}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>Sin Boletos</span>
                    </div>
                    </div>
                </el-table-column>
                <el-table-column label="Sube">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.pasajeros">
                    <div v-for="(pasajero, index) in row.pasajeros" :key="pasajero.id">
                      <span>{{ row.sube[index] }}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Baja">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.pasajeros">
                    <div v-for="(pasajero, index) in row.pasajeros" :key="pasajero.id">
                      <span>{{ row.baja[index] }}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Valor Boleto">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.valor_venta_boleto">
                    <div v-for="(valor, index) in row.valor_venta_boleto" :key="valor.id">
                      <span>{{valor}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Descuento">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.detalles_descuento">
                    <div v-for="(valor, index) in row.detalles_descuento" :key="valor.id">
                      <span>{{valor}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
            </el-table>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
            </form>

            <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showListaAbordajeModal = false">Cerrar</button>
            </template>
        </modal>

        <!-- MODAL CONFIRMAR PASAJERO QR -->
        <modal v-if="subRoute" :show.sync="showConfirmarAbordajeModal" modal-classes="modal-primary" size="lg">
            <div class="row">
            <h6 slot="header" class="mb-0 modal-title col-6">Confirmar Abordaje con QR</h6>
            <!--<button class="btn btn-default hover-apolo new-event--add ml-2 col-4" align="right" @click="imprimirListaAbordaje()">Imprimir</button>-->
            </div>
            <form class="new-event--form">
            <br>
            <p v-if="boarding.boleto_id">El último boleto leído por código QR es el #{{ boarding.boleto_id }}.</p>
            <p class="text-red -mt-2" v-if="statusBoardingError">{{ statusBoardingError }}</p>
            <p class="text-green -mt-2" v-if="statusBoarding">{{ statusBoarding }}</p>
            <qrcode-stream @decode="onDecode" @error="onError"
                :constraints="{ deviceId: selectedDevice.deviceId }"
                v-if="selectedDevice !== null && showConfirmarAbordajeModal"
            ></qrcode-stream>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
            </form>

            <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModalQR">Cerrar</button>
            </template>
        </modal>
    </div>
</template>

<script>
import Vue from 'vue';
import ClickOutside from 'v-click-outside';
import {Impresora} from "@/printer/Impresora.js";
import ImpresionListaAbordaje from "./ImpresionListaAbordaje.vue";
import { Modal } from "@/components/";
import {
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Option,
  Button,
} from "element-ui";
import Multiselect from 'vue-multiselect';
import { QrcodeStream } from 'vue-qrcode-reader';

Vue.use(ClickOutside);

import swal from "sweetalert2";
import { unwatchFile } from 'fs';
export default {
    components: {
        Multiselect,
        Modal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Option.name]: Option,
        [Button.name]: Button,
        QrcodeStream
    },
    data() {
        return {
            isPopoverVisible: false,
            equipajeDescripcion: '',
            selectedEquipaje: '',
            searchSubRoute: '',
            subRoute: '',
            showModalAdditional: '',
            searchTicketInput: '',
            selected: '',
            searchScroll: '',
            boletoBlanco: '',
            infoBoleto: '',
            items: [],
            headers: [
                { text: 'Asiento', value: 'asiento' },
                { text: 'Pasajero', value: 'pasajeros' },
                { text: '# Boleto', value: 'id' },
                { text: 'Abordado', value: 'abordado' },
                { text: 'Piezas Equipaje', value: 'piezas_equipaje' },
                { text: '', value: 'btn_doc' },
            ],
            error: '',
            exit: {
                type: "boleto",
                subcorridas_ids: null,
                token: null,
            },
            boarding: {
                type: "boleto",
                boleto_id: null,
                abordado: null,
                corrida_id: null,
                token: null,
            },
            boardingEquipaje: {
                type: "equipaje",
                equipaje_id: null,
                abordado: null
            },
            searchTicketM: {
                boleto_a_blanco_id: null,
                boleto_adelantar_id: null
            },
            canjeBlancoRes: {
                type: "boleto",
                boleto_a_blanco_id: null,
                se_adelanta_boleto: null,
                boleto_adelantar_id: null
            },
            listaAbordaje: [],
            showListaAbordajeModal: false,
            loading: true,
            subcorridas: null,
            route: null,
            searchSubcorridas: null,
            searchTerminalesDestino: null,
            validacion: null,
            user: null,
            permiso: false,
            permisoAbordaje: false,
            resultQR: {},
            selectedDevice: null,
            showConfirmarAbordajeModal: false,
            confirmation: false,
            statusBoarding: null,
            statusBoardingError: null,
            camera: null,
            lector: "",
            lectorTimer: null,
            TotalVentaCorrida: null,
            // Tab
            activeTab: 'abordaje',
            subcorridasFdt: null,
            routeFdt: null,
            // Fuera de tiempo
            showModalTokenFdt: false,
            tokenFdt: '',
            tokenFdtInput: '',
            fueraDetiempo: false,
            auth: {
                type: "autorizar",
                usuario: null,
                password: null,
                permiso: null,
                token: null
            },
        }
    },
    watch: {
        lector(newValue) {
            clearTimeout(this.lectorTimer);
            if (!newValue) return;
            this.lectorTimer = setTimeout(() => {
                this.confirmBoarding(newValue, "lector");
                this.lector = "";
            }, 200);
        },
        activeTab() {
            this.resetVista();
        }
    },
    computed:{
        confirmaSalida(){
            if(this.subRoute && this.subRoute.salida_confirmada === 0 && this.permisoAbordaje){
                return false;
            }else{
                return true;
            }
        }
    },
    created(){
        this.getRoutes();
        this.getOutTimeRoutes();
    },
    async mounted(){
        this.getCamera();
    },
    methods: {
        onScan() {
            clearTimeout(this.lectorTimer);
            this.lectorTimer = setTimeout(() => {
                this.confirmBoarding(this.lector, "lector");
                this.lector = "";
            }, 200);
        },
        resetVista() {
            this.subRoute = '';
            this.items = [];
            this.searchSubcorridas = null;
            this.searchScroll = '';
            this.lector = '';
            this.error = '';
            this.boarding.token = '';
            this.exit.token = '';
            this.auth.token = null;
            this.fueraDetiempo = this.activeTab === 'fuera_de_tiempo';
            if (this.activeTab === 'abordaje') {
                this.route = null;
            } else {
                this.routeFdt = null;
                this.tokenFdt = '';
                this.tokenFdtInput = '';
            }
        },
        selectSubRouteFdt() {
            this.searchSubcorridas = this.routeFdt.subcorridas_ids.split(',');
            this.tokenFdtInput = '';
            this.showModalTokenFdt = true;
        },
        confirmarTokenFdt() {
            if (!this.tokenFdtInput) {
                this.$notify({
                    type: "danger",
                    message: "El token es obligatorio.",
                    duration: -1
                });
                return;
            }
            this.tokenFdt = this.tokenFdtInput;
            //this.boarding.token = this.tokenFdt;
            //this.exit.token = this.tokenFdt;
            this.auth.token = this.tokenFdt;
            this.authToken();
        },
        async authToken() {
            try {
                await this.$store.dispatch("boletos/autorizacionToken", this.auth).then(() => {
                    this.$store.getters["boletos/autorizacionToken"];
                    this.boarding.token = this.tokenFdt;
                });
                this.$notify({
                    type: "success",
                    message: "Token autorizado satisfactoriamente.",
                    duration: -1
                });
                this.showModalTokenFdt = false;
                this.search(this.routeFdt.subcorridas_ids);
            } catch (error) {
                if (error.response.data.errors[0]) {
                    this.$notify({
                        type: "danger",
                        message: error.response.data.errors[0].detail,
                        duration: -1
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Oops, ha ocurrido un problema!",
                        duration: -1
                    });
                }
            }
        },
        cancelarTokenFdt() {
            this.showModalTokenFdt = false;
            this.routeFdt = null;
            this.subRoute = '';
            this.items = [];
            this.searchSubcorridas = null;
            this.tokenFdtInput = '';
        },
        confirmBoardingQR(){
            if(this.camera == null){
                this.getCamera();
            }
            this.resultQR = {};
            this.statusBoarding = null;
            this.statusBoardingError = null;
            this.showConfirmarAbordajeModal = false;
            this.boarding.boleto_id = null;
            this.showConfirmarAbordajeModal = true;
        },
        closeModalQR(){
            this.resultQR = {};
            this.statusBoarding = null;
            this.statusBoardingError = null;
            this.showConfirmarAbordajeModal = false;
            this.boarding.boleto_id = null;
        },
        onDecode(result) {
            this.resultQR.id = result;
            this.confirmBoarding(this.resultQR, 'qr')
        },
        onError(error) {
            if (error.name === 'NotAllowedError') {
            // user denied camera access permission
            } else if (error.name === 'NotFoundError') {
            // no suitable camera device installed
            } else if (error.name === 'NotSupportedError') {
            // page is not served over HTTPS (or localhost)
            } else if (error.name === 'NotReadableError') {
            // maybe camera is already in use
            } else if (error.name === 'OverconstrainedError') {
            // did you request the front camera although there is none?
            } else if (error.name === 'StreamApiNotSupportedError') {
            // browser seems to be lacking features
            }
        },
        async getCamera(){
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });

                stream.getTracks().forEach(track => track.stop());

                const devices = await navigator.mediaDevices.enumerateDevices();
                this.devices = devices.filter(({ kind }) => kind === 'videoinput');
                this.camera = this.devices;

                if (this.devices.length > 0) {
                    this.selectedDevice = this.devices[0];
                }
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    this.$notify({
                        type: "danger",
                        message: "Es necesario habilitar los permisos de cámara para esta función",
                        duration: -1
                    });
                } 
                console.error('Error accediendo a la cámara:', error);
            }
        },  
        async confirmBoardingBaggage(equipaje){
            const confirmation = await swal.fire({
                title: `Confirmación`,
                text: `¿Desea confirmar abordaje de Equipaje #` + equipaje.id + ` del Boleto #` + equipaje.boleto_id + `?`,
                type: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                confirmButtonClass: "btn btn-lg btn-default hover-apolo",
                cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
            });
            try {
                if (confirmation.value === true) {
                    this.boardingEquipaje.abordado = true;
                    this.boardingEquipaje.equipaje_id = equipaje.id;
                    await this.$store.dispatch("boarding/confirmBoardingBaggage", this.boardingEquipaje);
                    const ids = this.activeTab === 'abordaje' ? this.route.subcorridas_ids : this.routeFdt.subcorridas_ids;
                    await this.search(ids);
                    this.$notify({
                        type: "success",
                        message: "Abordaje de Equipaje confirmado correctamente",
                        duration: -1
                    });
                }
            } catch (error) {
                if (error.response.data.errors[0]) {
                    this.$notify({
                        type: "danger",
                        message: error.response.data.errors[0].detail,
                        duration: -1
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Oops, ha ocurrido un problema!",
                        duration: -1
                    });
                }
            }
        },
        async cancelBoardingBaggage(equipaje){
            const confirmation = await swal.fire({
                title: `Cancelación`,
                text: `¿Desea cancelar abordaje de Equipaje #` + equipaje.id + ` del Boleto #` + equipaje.boleto_id + `?`,
                type: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                confirmButtonClass: "btn btn-lg btn-default hover-apolo",
                cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
            });

            try {
                if (confirmation.value === true) {
                    this.boardingEquipaje.abordado = false;
                    this.boardingEquipaje.equipaje_id = equipaje.id;
                    await this.$store.dispatch("boarding/confirmBoardingBaggage", this.boardingEquipaje);
                    const ids2 = this.activeTab === 'abordaje' ? this.route.subcorridas_ids : this.routeFdt.subcorridas_ids;
                    await this.search(ids2);
                    this.$notify({
                        type: "success",
                        message: "Abordaje de Equipaje cancelado correctamente",
                        duration: -1
                    });
                }
            } catch (error) {
                if (error.response.data.errors[0]) {
                    this.$notify({
                        type: "danger",
                        message: error.response.data.errors[0].detail,
                        duration: -1
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Oops, ha ocurrido un problema!",
                        duration: -1
                    });
                }
            }
        },
        selectSubRoute(){
            this.searchSubcorridas = this.route.subcorridas_ids.split(',');
            this.search(this.route.subcorridas_ids);
        },
        validaPermiso(permisos){
            for(let i = 0; i < permisos.length; i++){
                if(permisos[i].name === 'view abordaje equipaje'){
                    this.permiso = true;
                }
                if(permisos[i].name === 'view abordaje'){
                    this.permisoAbordaje = true;
                }
            }
        },
        async getRoutes(){
            await this.$store.dispatch("profile/me");
            this.user = await { ...this.$store.getters["profile/me"] };
            this.validaPermiso(this.user.relationships.role.permissions);
            await this.$store.dispatch("boarding/getlistado").then(() => {
                this.subcorridas = this.$store.getters["boarding/getlistado"];
            });
        },
        async getOutTimeRoutes(){
            await this.$store.dispatch("boarding/getlistadoFdt").then(() => {
                this.subcorridasFdt = this.$store.getters["boarding/getlistadoFdt"];
            });
        },
        async search(subcorridas_ids) {
            this.ticket = '';
            this.error = '';
            this.items = [];
            let params = [];
            params.subcorridas_ids = subcorridas_ids;
            params.token = this.auth.token;
            await this.$store.dispatch("boarding/get", params)
                .then(() => {
                    this.subRoute = this.$store.getters["boarding/get"];
                    this.items = this.subRoute.lista_de_abordaje.filter(item => (item.boleto && item.boleto.id) || item.pasajeros.length > 0);
                    this.auth.token = '';
                })
                .catch(error => {
                    if (error.response.data.errors[0]) {
                        this.$notify({
                            type: "danger",
                            message: error.response.data.errors[0].detail,
                            duration: -1
                        });
                    } else {
                        this.$notify({
                            type: "danger",
                            message: "Oops, ha ocurrido un problema!",
                            duration: -1
                        });
                    }
                })
        },
        async searchTicket(boleto) {
            this.error = '';
            this.searchTicketM.boleto_a_blanco_id = boleto.itemId;
            this.searchTicketM.boleto_adelantar_id = boleto.searchText;
            await this.$store.dispatch("boarding/searchTicket", this.searchTicketM)
                .then(() => {
                    this.boletoBlanco = this.$store.getters["boarding/searchTicket"];
                    this.infoBoleto = this.boletoBlanco.result.boleto_adelantar;
                })
                .catch(error => {
                    if (error.response.data.errors[0]) {
                        this.$notify({
                            type: "danger",
                            message: error.response.data.errors[0].detail,
                            duration: -1
                        });
                    } else {
                        this.$notify({
                            type: "danger",
                            message: "Oops, ha ocurrido un problema!",
                            duration: -1
                        });
                    }
                })
        },
        async canjeBlanco(canje) {
            if (canje.se_adelanta_boleto === true) {
                this.canjeBlancoRes.boleto_a_blanco_id = canje.boleto_a_blanco_id;
                this.canjeBlancoRes.se_adelanta_boleto = canje.se_adelanta_boleto;
                this.canjeBlancoRes.boleto_adelantar_id = canje.boleto_adelantar_id;
            } else {
                this.canjeBlancoRes.boleto_a_blanco_id = canje;
                this.canjeBlancoRes.se_adelanta_boleto = false;
            }
            await this.$store.dispatch("boarding/canjeBlanco", this.canjeBlancoRes)
                .then(() => {
                    this.infoRes = this.$store.getters["boarding/canjeBlanco"];
                    this.searchTicketInput = '';
                    this.selected = '';
                    const ids = this.activeTab === 'abordaje' ? this.route.subcorridas_ids : this.routeFdt.subcorridas_ids;
                    this.search(ids);
                    this.closeModalAdditional();
                    this.$notify({
                        type: "success",
                        message: this.infoRes.message,
                        duration: -1
                    });
                })
                .catch(error => {
                    if (error.response.data.errors[0]) {
                        this.$notify({
                            type: "danger",
                            message: error.response.data.errors[0].detail,
                            duration: -1
                        });
                    } else {
                        this.$notify({
                            type: "danger",
                            message: "Oops, ha ocurrido un problema!",
                            duration: -1
                        });
                    }
                })
        },
        validaSalida(){
            let valida = 0;
            for(let i = 0; i < this.subRoute.lista_de_abordaje.length; i++){
                if(this.subRoute.lista_de_abordaje[i].boleto != null){
                    if(this.subRoute.lista_de_abordaje[i].boleto.abordado === 0){
                        for(let j = 0; j < this.subRoute.lista_de_abordaje[i].boleto.equipajes.length; j++){
                            if(this.subRoute.lista_de_abordaje[i].boleto.equipajes[j].abordado === 1){
                                valida++
                            }
                        }   
                    }
                }
            }
           return valida;
        },
        async confirmDeparture(ids) {
            console.log('llegas')
            console.log(ids)
            
            this.validacion = this.validaSalida();
            if(this.validacion === 0){
                this.validacion = " ";
            }else if (this.validacion === 1){
                this.validacion = `Se encontró un equipaje abordado con pasajero sin abordar,`;
            }else{
                this.validacion = `Se encontraron ${this.validacion} equipajes abordados con pasajeros sin abordar,`;
            }
            const confirmation = await swal.fire({
                title: `Confirmación`,
                text: `${this.validacion} ¿Desea confirmar la salida de estas Sub-Corridas? `,
                type: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                confirmButtonClass: "btn btn-lg btn-default hover-apolo",
                cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
            });
            this.exit.subcorridas_ids = ids;
            try {
                if (confirmation.value === true) {
                    await this.$store.dispatch("boarding/confirmDeparture", this.exit);
                    const ids = this.activeTab === 'abordaje' ? this.route.subcorridas_ids : this.routeFdt.subcorridas_ids;
                    await this.search(ids);
                    this.$notify({
                        type: "success",
                        message: "Salida de Subcorrida confirmada correctamente",
                        duration: -1
                    });
                    this.listaAbordaje = [];
                    this.listaAbordaje = this.subRoute.lista_de_abordaje;
                    await this.imprimirListaAbordaje();
                }
            } catch (error) {
                if (error.response.data.errors[0]) {
                    this.$notify({
                        type: "danger",
                        message: error.response.data.errors[0].detail,
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Oops, ha ocurrido un problema!",
                        duration: -1
                    });
                }
            }
        },
        async confirmBoarding(confirm, type) {
            //this.lector = null;
            this.statusBoarding = null;
            this.statusBoardingError = null;
            if(type == 'lista'){
                this.confirmation = await swal.fire({
                    title: `Confirmación`,
                    text: `¿Desea confirmar abordaje de Boleto # ` + confirm.id + ` del Pasajero ` + confirm.nombre_pasajero + `?`,
                    type: "question",
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                    confirmButtonClass: "btn btn-lg btn-default hover-apolo",
                    cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
                });
            }else{
                this.confirmation = {value: null};
                this.confirmation.value = true;
            }
            try {
                if (this.confirmation.value === true) {
                    this.boarding.corrida_id = this.subRoute.corrida_id
                    this.boarding.abordado = true;
                    if(type == 'lector'){
                        this.boarding.boleto_id = confirm
                    }else{
                        this.boarding.boleto_id = confirm.id;
                    }
                    await this.$store.dispatch("boarding/confirmBoarding", this.boarding);
                    this.statusBoarding = "Abordaje confirmado correctamente del boleto: #"+this.boarding.boleto_id
                    const ids = this.activeTab === 'abordaje' ? this.route.subcorridas_ids : this.routeFdt.subcorridas_ids;
                    await this.search(ids);
                    this.$notify({
                        type: "success",
                        message: this.statusBoarding,
                        duration: -1
                    });
                    this.boarding.boleto_id = null;
                }
            } catch (error) {
                if (error.response.data.errors[0]) {
                    this.statusBoardingError = error.response.data.errors[0].detail;
                    this.$notify({
                        type: "danger",
                        message: error.response.data.errors[0].detail,
                        duration: -1
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Oops, ha ocurrido un problema!",
                        duration: -1
                    });
                }
            } finally {
                this.$nextTick(() => {
                this.$refs.lectorInput?.focus();
                });
            }
        },
        async cancelBoarding(confirm) {
            const confirmation = await swal.fire({
                title: `Cancelación`,
                text: `¿Desea cancelar abordaje de Boleto # ` + confirm.id + ` del Pasajero ` + confirm.nombre_pasajero + `?`,
                type: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                confirmButtonClass: "btn btn-lg btn-default hover-apolo",
                cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
            });

            try {
                if (confirmation.value === true) {
                    this.boarding.abordado = false;
                    this.boarding.boleto_id = confirm.id;
                    this.boarding.corrida_id = this.subRoute.corrida_id;
                    await this.$store.dispatch("boarding/confirmBoarding", this.boarding);
                    const ids = this.activeTab === 'abordaje' ? this.route.subcorridas_ids : this.routeFdt.subcorridas_ids;
                    await this.search(ids);
                    this.$notify({
                        type: "success",
                        message: "Abordaje de Boleto cancelado correctamente",
                        duration: -1
                    });
                    this.boarding.boleto_id = null;
                }
            } catch (error) {
                if (error.response.data.errors[0]) {
                    this.$notify({
                        type: "danger",
                        message: error.response.data.errors[0].detail,
                        duration: -1
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Oops, ha ocurrido un problema!",
                        duration: -1
                    });
                }
            }
        },
        closeModalAdditional() {
            this.searchTicketInput = '',
                this.selected = '',
                this.showModalAdditional = false;
        },
        scrollToResult() {
            if (!this.searchScroll || !this.items) return;

            const targetRow = this.items.find((item) => {
                if (item.boleto) {
                    return item.boleto.id === parseInt(this.searchScroll);
                } else {
                    return item.boleto_pasajero.includes(this.searchScroll);
                }
            });

            if (targetRow) {
                const targetIndex = this.items.indexOf(targetRow);
                const targetElement = this.$el.querySelector(`tbody tr:nth-child(${targetIndex + 1})`);

                targetElement.classList.add('highlight');

                setTimeout(() => {
                    targetElement.classList.remove('highlight');
                }, 1500);

                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                this.$notify({
                    type: "danger",
                    message: "El boleto buscado no se encontró.",
                    duration: -1
                });
            }
        },
        showEquipajeDescripcion(descripcion, equipaje) {
            this.equipajeDescripcion = descripcion;
            this.selectedEquipaje = equipaje;
        },
        togglePopover(equipaje, event) {
            this.showEquipajeDescripcion(equipaje.descripcion_equipaje, equipaje);

            if (this.equipajeDescripcion === null) {
                this.isPopoverVisible = false;
            } else if (this.selectedEquipaje === equipaje && this.isPopoverVisible) {
                this.selectedEquipaje = null;
                this.isPopoverVisible = false;
            } else {
                this.selectedEquipaje = equipaje;
                this.isPopoverVisible = true;
                this.updatePopoverPosition(event.target);
            }
        },
        updatePopoverPosition(target) {
            const popover = this.$refs.popover;
            popover.$refs.referenceElm = target;
            popover.$nextTick(() => {
                popover.updatePopper();
            });
        },
        onClickOutside() {
            this.isPopoverVisible = false;
            this.selectedEquipaje = null;
        },
        isBold(item, pasajero, pasajeroIndex) {
            return item.boleto &&  item.boleto.nombre_pasajero === pasajero && item.sube[pasajeroIndex] && item.baja[pasajeroIndex]
        },
        async listaAbordajeModal($id){
            this.listaAbordaje = [];
            this.listaAbordaje = this.subRoute.lista_de_abordaje;
            await this.$store.dispatch("corridas/getTotalVentaCorrida", this.subRoute.corrida_id).then(() => {
                this.TotalVentaCorrida = this.$store.getters["corridas/getTotalVentaCorrida"];
            });
            this.showListaAbordajeModal = true;
        },
        async addImageToPrint(linea){
            //transforma imagen a base64
            const getBase64FromUrl = async (url) => {
            const data = await fetch(url);
            const blob = await data.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob); 
                reader.onloadend = () => {
                const base64data = reader.result;   
                resolve(base64data);
                }
            });
            }
            let imagen;
            //elige imagen a imprimir según linea de ruta
            switch(linea){
            case 1:
                imagen = await getBase64FromUrl('/img/logoPrinter2.png');
                return imagen;
            case 2:
                imagen = await getBase64FromUrl('/img/logoPrinter3.png');
                return imagen;
            }
        },
        async imprimirListaAbordaje(){
            //se obtienen datos de usuario autenticado
            let me = await this.$store.getters["profile/me"];
            let imagen = await this.addImageToPrint(this.listaAbordaje[0].linea);

            let printer = new Impresora;
            let tablaClass = Vue.extend(ImpresionListaAbordaje);
            let tablaInstancia = new tablaClass({
                propsData: { 
                    lista: this.listaAbordaje,
                    user: me.attributes,
                    corrida: this.subRoute
                }
            });
            let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
            let tabla = this.changeSimbol(tabla_html);
            printer.setAlign("center");
            printer.imagen(imagen);
            printer.setAlign("left");
            printer.html(tabla);
            printer.cut();
            printer.end().then(respuesta => {
                console.log(respuesta);
            });
        },
        changeSimbol(s) {
            var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
            if (!s) { return ''; }
            var ret = '';
            for (var i = 0; i < s.length; i++) {
                ret += accent_map[s.charAt(i)] || s.charAt(i);
            }
            return ret;
        },
        nombreCompleto ({ corrida_id, abreviatura_terminal_origen, abreviatura_terminales_destino, fecha_salida_real, numero_economico }) {
            if (numero_economico === null) numero_economico = '';
            fecha_salida_real = this.$moment(fecha_salida_real).format('DD-MM-YYYY HH:mm');
            return `#${corrida_id} ${abreviatura_terminal_origen} - ${abreviatura_terminales_destino} ${fecha_salida_real} ${numero_economico}`
        },
    }
}
</script>

<style lang="scss">
.argon-error {
    position: relative;
    bottom: 25px !important;
    color: #fb6340;
}

.table-container {
    overflow-x: auto !important;
    white-space: nowrap !important;
}

.argon-error {
    position: relative;
    bottom: 25px !important;
    color: #fb6340;
}

.search-size {
    width: 300px !important;
    flex: none !important;
}

.search-size02 {
    width: 300px !important;
    flex: none !important;
}

.header-white thead th {
    background-color: #0068a0;
    color: white;
}

.two-lines {
    white-space: pre-line !important;
}

.highlight {
    background-color: rgb(193, 226, 142) !important;
}

.hipervinculo {
    cursor: pointer;
    text-decoration: underline;
    color: blue;
}

.hipervinculo:hover {
    color: red;
}

.el-tab-pane {
    overflow: visible !important;
}

.el-tabs__content {
    overflow: visible !important;
}
</style>